"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouteInfo } from "@hooks/pages/use-route-info";
import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { AppSidebarGroup } from "@components/app/app-sidebar/app-sidebar-group";
import { useAnyTranslations } from "@lib/i18n/utils";
import { appTools } from "@features/application/app-tools";
import { useAppSelector } from "@lib/redux/hooks";
import { selectSessionUser } from "@features/application/app-selectors";
import { selectUserWorkspaces } from "@features/workspaces/workspaces-selectors";
interface NavApplicationProps {
  isPrivateMode?: boolean;
}
export const NavApplication = t0 => {
  const $ = _c(11);
  const {
    isPrivateMode
  } = t0;
  const t = useTranslations("features.application.ui.nav-application");
  const tAny = useAnyTranslations();
  const pageInfo = useRouteInfo();
  const user = useAppSelector(selectSessionUser);
  const workspaces = useAppSelector(selectUserWorkspaces);
  const showDashboardWithWorkspaces = Array.isArray(workspaces) && workspaces.length > 0;
  let t1;
  if ($[0] !== isPrivateMode || $[1] !== pageInfo || $[2] !== showDashboardWithWorkspaces || $[3] !== tAny || $[4] !== user) {
    t1 = appTools.buildSidebarMenuItems(tAny, pageInfo, user, isPrivateMode, showDashboardWithWorkspaces);
    $[0] = isPrivateMode;
    $[1] = pageInfo;
    $[2] = showDashboardWithWorkspaces;
    $[3] = tAny;
    $[4] = user;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const menuItems = t1;
  let t2;
  if ($[6] !== t) {
    t2 = t("title");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== menuItems || $[9] !== t2) {
    t3 = <AppSidebarGroup title={t2} items={menuItems} />;
    $[8] = menuItems;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};